import React, {useRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../../redux/store";
import {
    bannerStatus, loadingBanners,
    selectBanner,
    selectCountProd,
    selectFilter,
    selectFilterTitle, selectSlide,
    selectSortTitle,
    selectTableContent, selectTime,
    selectZoomedTime, setError,
    visiblePDF
} from "../../../common/selectors";
import {DataTableResType} from "../../../common/types";
import dayjs from "dayjs";
import {
    clearStatusAC,
    fetchBanners,
    selectParamsAC,
    selectSlideAC,
    selectSortTitleAC
} from "../../../redux/tableReducer";
import {TableComponent} from "../tableComponent/tableComponent";
import {plainOptionsMps} from "../../../common/optionsTableShares";
import styles from "./tableMps.module.sass";
import {formatGrade} from "../../../common/optionsForCategories/table";
import {Button, Popover} from "antd";
import {CloseCircleOutlined, VerticalAlignBottomOutlined} from "@ant-design/icons";
import {Carousel} from "../carousel/carousel";
import {Uploader} from "../../options/uploader/uploader";
import {current} from "@reduxjs/toolkit";
import {Spinner} from "../../../common/spin";
import {setErrorAC} from "../../../redux/authReducer";


const titleTableMps: {[index: string]:string} = {
    name_sale: 'Наименование',
    //count_categories: 'Кол-во категорий',
    count_products: 'Кол-во товаров',
    average_percent: 'Анонсируемая скидка',
    get_date_row: 'Дата начала',
    to_date: 'Дата завершения'
}

// Компонент таблицы акций и скидок по маркетплейсам
export const TableMarketplaces = () => {
    // Получаем dispatch для работы с redux
    const dispatch = useAppDispatch()

    // Получаем данные для таблицы маркетплейсов
    const tableContent = useAppSelector(selectTableContent)
    // Получаем фильтр
    const filter = useAppSelector(selectFilter)
    // Получаем временной диапазон для зума
    const zoom = useAppSelector(selectZoomedTime)
    // Получаем временной диапазон
    const time = useAppSelector(selectTime)
    // Получаем параметры сортировки
    const sortTitle = useAppSelector(selectSortTitle)
    // Получаем выбранные маркетплейсы
    const filterTitle = useAppSelector(selectFilterTitle)
    // Получаем количество товаров
    const countProd = useAppSelector(selectCountProd)
    // Получаем состояние видимости PDF
    const visible = useAppSelector(visiblePDF)
    // Получаем баннеры
    const banner = useAppSelector(selectBanner)
    // Получаем статус загрузки баннеров
    const status = useAppSelector(bannerStatus)
    // Получаем текущий слайд
    const slideState = useAppSelector(selectSlide)
    // Получаем статус загрузки
    const loading = useAppSelector(loadingBanners)

    // Функция сортировки по заголовку
    const sortTitleFunc = (title:string) => {
        if (sortTitle.name !== title) {
            dispatch(selectSortTitleAC({...sortTitle, name: title, direction: true}))
        }
        if (sortTitle.name === title) {
            dispatch(selectSortTitleAC({...sortTitle, name: title, direction: !sortTitle.direction}))
        }
    }

    // Фильтрация и сортировка данных таблицы
    const filteredTableContent = tableContent
        .filter((el: DataTableResType) => filter.includes(el.spm))
        .filter((el) => filterTitle.includes(el.spm))
        .sort((a,b) => dayjs(b.get_date_row).valueOf() - dayjs(a.get_date_row).valueOf())
        .filter((el) => {
            return (el.get_date_row < zoom[0]! && el.to_date >= zoom[0]!) ||
                (el.get_date_row >= zoom[0]! && el.get_date_row <= zoom[1]! && el.to_date >= zoom[0]! && el.to_date <= zoom[1]!) ||
                (el.get_date_row <= zoom[1]! && el.to_date >= zoom[1]!)
        })

    // Кастомная сортировка по площадкам
    function customSort(a:DataTableResType[], s:string[]) {
        return a.sort(function(x1, x2) {
            let i1 = s.indexOf(x1.spm),
                i2 = s.indexOf(x2.spm);
            return i1 < 0 ? 1 : i2 < 0 ? -1 : i1 - i2;
        })
    }
    customSort(filteredTableContent, plainOptionsMps);

    // Альтернативная сортировка по площадкам
    const customSort1 = (a:DataTableResType[],b:string[]) => {
        let result:DataTableResType[] = []
        b.forEach((el) => {
            a.forEach((item) => el === item.spm ? result.push(item) : item)
        })
        return result
    }

    // Сортировка данных по выбранному столбцу
    const sortTableContent = filteredTableContent
        .sort((a,b) => {
            if (sortTitle.name === 'spm') {
                customSort1(filteredTableContent, plainOptionsMps)
            }
            if (sortTitle.name === 'name_sale' && sortTitle.direction) {
                return  a.name_sale.localeCompare(b.name_sale)
            }
            if (sortTitle.name === 'name_sale' && !sortTitle.direction) {
                return  b.name_sale.localeCompare(a.name_sale)
            }
            if (sortTitle.name !== 'name_sale' && sortTitle.direction) {
                return dayjs(a[sortTitle.name]).valueOf() - dayjs(b[sortTitle.name]).valueOf()
            }
            if (sortTitle.name !== 'name_sale' && !sortTitle.direction) {
                return dayjs(b[sortTitle.name]).valueOf() - dayjs(a[sortTitle.name]).valueOf()
            }
            return dayjs(a[sortTitle.name]).valueOf() - dayjs(b[sortTitle.name]).valueOf()
        })

    // Состояние выбранного id
    const [id, setId] = useState(0)
    // Состояние блока поповера
    const [block, setBlock] = useState(false)
    // Состояние текущего слайда
    const [slide, setSlide] = useState<number>(0)
    // Состояние открытия поповера
    const [open, setOpen] = useState(false)

    // Обработчик клика по строке таблицы
    const onClickId = (idRow: number,
                       name_sale: string,
                       spm: string,
                       from_date: string,
                       to_date: string,
                       from_date_sale: string,
                       to_date_sale: string
    ) => {
        dispatch(fetchBanners({name_sale, spm: spm,  from_date, to_date, from_date_sale, to_date_sale}))
        dispatch(selectParamsAC({name_sale, spm: spm,  from_date, to_date, from_date_sale, to_date_sale}))
        setId(idRow)
        setSlide(0)
        setOpen(!open)
    }

    // Обработчик скрытия поповера
    const hide = () => {
        setBlock(false);
        setId(0);
    };

    // Обработчик клика по элементу таблицы
    const onClickTableItem = () => {
        setId(0);
        setBlock(!block)
    }

    // Обработчик смены слайда в карусели
    const carouselHandler = (current: number) => {
        setSlide(current)
        dispatch(selectSlideAC(current))
    }

    // Формирование строк таблицы с поповером
    const tableRow = sortTableContent.map((el: DataTableResType, index) =>
        <Popover
            key={index}
            placement="left"
            content={
            <div >
                <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div style={{width: '85%'}}>{el.name_sale}</div>
                    <Button type={"link"} icon={<CloseCircleOutlined />} onClick={hide} />
                </div>
                {loading === 'loading' ? <Spinner/> :
                    <Carousel data={banner} callBack={carouselHandler} slide={slideState} open={open}/>}
            </div>
        }
            trigger="click"
            open={id === el.id &&block}
            onOpenChange={onClickTableItem}
        >
            <div  key={index} style={{backgroundColor: el.colors, color: el.text, cursor: 'pointer', opacity: id === el.id || !block ? 1 : .5}} className={styles.tableRow}>
                <div  className={styles.tableItem}>{el.name_sale}</div>
                <div className={styles.tableItem}>
                <span
                    className={styles.titleItem}>{titleTableMps.count_products}
                </span>
                    {el.count_products === 0?
                        <span>
                        -
                        </span>
                        :
                        <span>
                        {formatGrade(el.count_products!)}
                    </span>
                    }
                </div>
                <div className={styles.tableItem}><span
                    className={styles.titleItem}>{titleTableMps.average_percent}</span><span>{el.average_percent}</span></div>
                <div className={styles.tableItem}><span
                    className={styles.titleItem}>{titleTableMps.get_date_row}</span><span>{el.get_date_row}</span></div>
                <div className={styles.tableItem}><span
                    className={styles.titleItem}>{titleTableMps.to_date}</span><span>{el.to_date}</span></div>
            </div>
        </Popover>
        )

    // ...рендер...
    return (
        <>
            <TableComponent
                name={'marketplaces'}
                titleTable={titleTableMps}
                tableContent={tableContent}
                filter={filter}
                zoom={zoom}
                sortTitle={sortTitle}
                filterTitle={filterTitle}
                countProd={countProd}
                visible={visible}
                sortTitleFunc={sortTitleFunc}
                filteredTableContent={filteredTableContent}
                sortTableContent={sortTableContent}
                plainOptions={plainOptionsMps}
                tableRow={tableRow}
            />
        </>
    );
};
// ...конец файла...
